/// <amd-module name="Test/TestPlansLibrary/TestCasesPivotMenuService/TestCasesPivotMenuProviderService" />
import { ITestCasesPivotContextMenuParams } from "./TestCasesPivotMenuService.types";
import * as Resources from "Test/TestPlansLibrary/TestCasesPivotMenuService/Resources";
import { WorkItemConstants, TestPlansLibraryConstants } from "Test/TestPlansLibrary/LibraryHub/Constants";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IMenuService } from "VSS/Features/PlatformUI/ContributedMenu";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { routeUrl } from "VSS/Platform/Location";
import { IMenuItem } from "VSSUI/Menu";

// This class is a provider service class to get the context menu options for test case item(s).
export class TestCasesPivotMenuProviderService extends VssService implements IMenuService {
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this.pageContext = pageContext;
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
    }

    public openTestCaseWITForm = (params: ITestCasesPivotContextMenuParams) => {
        const testCaseIndex = params.selection.value[0].beginIndex;
        const testCaseId = params.testCases[testCaseIndex].id;

        const tfsPageService = this.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        let projectName: string = "";

        if (tfsPageData && tfsPageData.project) {
            projectName = tfsPageData.project.name;
        }

        const workItemUrl: string = routeUrl(this.pageContext, "ms.vss-test-web.testplans-workitem-page-route", {
            project: projectName,
            type: TestPlansLibraryConstants.TestCaseTabId,
            mode: WorkItemConstants.WorkItemEditMode,
            id: String(testCaseId)
        });

        FastPageSwitch(this.pageContext, workItemUrl, true);
    };

    public getMenuItems(menuId: string, props: ITestCasesPivotContextMenuParams): IMenuItem[] | null {
        const menuItems: IMenuItem[] = [];
        if (menuId === "ms.vss-test-web.test-case-workitem-context-menu") {
            if (props.selection.selectedCount === 1) {
                menuItems.push({
                    id: "view-linked-items",
                    text: Resources.ViewLinkedItems,
                    iconProps: { iconName: "Link", className: "link-icon" },
                    onActivate: (menuItem: IMenuItem) => {
                        if (props.linkedItemsPanelOpen) {
                            props.linkedItemsPanelOpen();
                        }
                    },
                    data: props
                });
                menuItems.push({
                    id: "open-test-case",
                    text: Resources.OpenTestCase,
                    iconProps: { iconName: "FullScreen", className: "open-testcase-icon" },
                    onActivate: (menuItem: IMenuItem) => {
                        this.openTestCaseWITForm(props);
                    },
                    data: props
                });
            }
        }
        return menuItems;
    }
}
Services.add("testcases-pivot-menu-provider", { serviceFactory: TestCasesPivotMenuProviderService });
